export function sanitise(value: any): any {
  if (typeof value === "string") {
    return value.replace(/<[^>]*>?/gm, "").trim();
  }
  if (Array.isArray(value)) {
    return value.map(sanitise);
  }
  if (value && typeof value === "object") {
    if (value instanceof Date) {
      return value;
    }
    if (value instanceof File) {
      const sanitisedName = value.name.replace(/<[^>]*>?/gm, "-").trim();
      return new File([value], sanitisedName, {
        type: value.type,
        lastModified: value.lastModified
      });
    }
    return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, sanitise(val)]));
  }
  return value;
}

export function sanitiseParams(paramsToSanitise?: number[]): MethodDecorator {
  return function (_target: any, _propertyKey: string | symbol, descriptor: PropertyDescriptor): PropertyDescriptor {
    const originalMethod = descriptor.value;

    descriptor.value = async function (...args: any[]): Promise<any> {
      const sanitisedArgs = args.map((arg, index) => {
        if (!paramsToSanitise || paramsToSanitise.includes(index)) {
          return sanitise(arg);
        } else {
          return arg;
        }
      });
      const result = await originalMethod.apply(this, sanitisedArgs);

      return result;
    };
    return descriptor;
  };
}
